import axios from 'axios';

const API_URL = 'https://h1fj6nbqm6.execute-api.us-east-1.amazonaws.com/prod/portco';

export const GetAllPortfolioCompanies = async () => {
  console.log("PortcoAPIHelper :: GetAllPortfolioCompanies :: Starting");
  try {
    const response = await axios.get(API_URL, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });
    console.log("PortcoAPIHelper :: GetAllPortfolioCompanies :: response :: ", response);
    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};

export const GetPortfolioCompanyById = async (portcoId) => {
  console.log("PortcoAPIHelper :: GetPortfolioCompanyById :: Starting");
  try {
    const response = await axios.get(`${API_URL}?portcoId=${portcoId}`, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });
    console.log("PortcoAPIHelper :: GetPortfolioCompanyById :: response :: ", response);
    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};

export const UpdatePortfolioCompany = async (portcoId, companyName, companyLegalName, pitchbookId, websiteUrl, websiteBlurb, showOnPublicWebsite) => {
    try {
      const requestBody = {
        company_name: companyName,
        company_legal_name: companyLegalName,
        pitchbook_id: pitchbookId,
        website_url: websiteUrl,
        website_blurb: websiteBlurb,
        show_on_public_website: showOnPublicWebsite
      };
      if (portcoId !== null && portcoId !== "") {
        requestBody.portco_id = portcoId;
      }
      console.log(requestBody);
      const response = await axios.put(API_URL, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${token}`
        },
      });

      if (response.status === 200) {
        return response;
      } else {
        console.error('Error:', response.status, response.statusText);
        return null;
      }
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  };
  

export const DeletePortfolioCompany = async (portcoId) => {
  try {
    const url = `${API_URL}?portcoId=${portcoId}`;

    const response = await axios.delete(url, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};
